import React, { useMemo } from 'react';
import MaskedInput from 'react-maskedinput';
import shortUUID from 'short-uuid';
import { ValidateError } from '../ErrorMessage';

import './styles.css';

export const InputMaskField = ({
  id,
  className,
  large,
  value,
  label,
  disabled,
  mask,
  size,
  inputMode,
  pattern,
  field,
  form,
  onChange,
  onBlur,
  ...otherProps
}) => {
  const uuid = useMemo(() => shortUUID().generate(), []);

  return (
    <div className={className}>
      {label && (
        <label
          className={`label ${disabled ? 'disabled' : ''} ${
            form &&
            form.errors[field.name] &&
            form.touched[field.name] &&
            'error'
          }`}
          htmlFor={id || uuid}
        >
          {label}
        </label>
      )}
      <div className={`text-input-wrapper ${label ? '' : 'no-label'}`}>
        {field ? (
          <>
            <MaskedInput
              id={id || uuid}
              className={`text-input ${
                form &&
                form.errors[field.name] &&
                form.touched[field.name] &&
                'error'
              }`}
              inputMode={inputMode}
              pattern={pattern}
              disabled={disabled}
              mask={mask}
              size={size}
              onBlurCapture={onBlur}
              onChange={onChange}
              {...field}
            />
            {!form.isValid &&
              form.touched[field.name] &&
              form.errors[field.name] && (
                <ValidateError>{form.errors[field.name]}</ValidateError>
              )}
          </>
        ) : (
          <MaskedInput
            id={id || uuid}
            {...otherProps}
            className={`text-input ${large && 'large'}`}
            value={value}
            mask={mask}
            inputMode={inputMode}
            pattern={pattern}
            size={size}
            onChange={(e) => onChange(e.target.value)}
          />
        )}
      </div>
    </div>
  );
};
